import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ASSETS_HOST: process.env.VUE_APP_ASSETS_HOST,
    API_HOST: process.env.VUE_APP_API_HOST,
    favouritesString: new URL(location.href).searchParams.get('p'),
    isLeadFormTimeoutFinished: false,
    isLoading: true,
    isReturningUser: false,
    message: new URL(location.href).searchParams.get('m'),
    properties: [],
  },

  getters: {
    favouritePropertyIds (state) {
      return state.favouritesString ? state.favouritesString.split(',') : []
    },

    favouritePropertyLabels (state, getters) {
      return getters.favouriteProperties.map(property => property.label)
    },

    favouriteProperties (state, getters) {
      const unsortedFavouriteProperties = state.properties.filter(property => {
        return getters.favouritePropertyIds.includes(property._id)
      })

      let sortedFavouriteProperties = []
      
      getters.favouritePropertyIds.map(propertyId => {
        const property = unsortedFavouriteProperties.find(property => property._id.toString() === propertyId)
        if (property) {
          sortedFavouriteProperties.push(property)
        }
      })

      return sortedFavouriteProperties
    },

    isValidFavourites (state, getters) {
      return Boolean(getters.favouriteProperties.length)
    },

    isLeadFormTimeoutFinished: state => state.isLeadFormTimeoutFinished,

    isLoading: state => state.isLoading,

    isReturningUser () {
      const returningParam = new URL(location.href).searchParams.get('r') === '1'
      const returningCookie = document.cookie.replace(/(?:(?:^|.*;\s*)r\s*=\s*([^;]*).*$)|^.*$/, '$1') == '1'
      return returningParam || returningCookie
    },

    message: state => state.message,

    structuredPropertyData (state, getters) {
      let structuredPropertyData = []
      if (getters.isValidFavourites) {
        getters.favouriteProperties.forEach(property => {
          let livingOption = structuredPropertyData.find(livingOption => livingOption._id === property.livingOption._id)
          if (!livingOption) {
            livingOption = JSON.parse(JSON.stringify(property.livingOption))
            structuredPropertyData.push(livingOption)
          }
          livingOption.properties = livingOption.properties || []
          livingOption.properties.push(property)
        })
      }
      return structuredPropertyData
    },
  },

  mutations: {
    SET_PROPERTIES (state, properties) {
      state.properties = properties
    },

    LEADFORM_TIMEOUT_FINISHED (state) {
      state.isLeadFormTimeoutFinished = true
    }
  },

  actions: {
    async fetchProperties ({ state, commit }) {
      state.isLoading = true
      await axios.get(state.API_HOST + '/properties/favourites').then(res => {
        commit('SET_PROPERTIES', res.data)
      })
      // get favourite dwellings
      // await axios.post(state.API_HOST + '/properties/favourites-new', {ids: state.favouritesString}).then(res => {
      //   commit('SET_PROPERTIES', res.data)
      // })
      state.isLoading = false
    },
  },
})
